import { CSSProperties, memo, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { mdlBaseHotelIdRequest } from "../../models/service-models/common/BaseHotelIdRequest";
import { BoardService } from "../../services/BoardService";

export type HotelBoardNameSelectProps = {
    onChange?: Function;
    value?: string | string[];
    disabled?: boolean;
    defaultValue?: string | string[];
    excludedValue?: string;
    mode?: 'multiple' | 'tags' | undefined;
    style?: CSSProperties;
    sendObject?: boolean;
    hotelId?: string;
}

export const HotelBoardNameSelect = (props: HotelBoardNameSelectProps) => {
    const [selectedBoardName, setSelectedBoardName] = useState<string | string[]>();
    const { t } = useTranslation();
    useEffect(() => {
        if (!data)
            refetch();
        if (props.defaultValue) {
            setSelectedBoardName(props.defaultValue)
        }
        if (props.value)
            setSelectedBoardName(props.value);
    }, [props]);

    const {
        data,
        isLoading,
        isError,
        refetch
    } = useQuery(
        ["getHotelBoardName", props.hotelId],
        () => {
            if (props.hotelId) {
                var request: mdlBaseHotelIdRequest = { hotelId: props.hotelId };
                return BoardService.BoardNameList(request);
            }
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!props.hotelId
        }
    );

    const handleSendObject = (option: any) => {
        const selectedOption = Array.isArray(option) ? option.map(opt => opt) : option;
        props.onChange!(selectedOption);
    }

    return (
        <>
            <Select
                disabled={props.disabled}
                loading={isLoading || !data}
                size="middle"
                mode={props.mode}
                value={props.mode == "multiple" ? selectedBoardName as string[] : selectedBoardName as string}
                style={props.style && props.style}
                defaultValue={props.defaultValue}
                onChange={(value: string | string[], option: any) =>
                    props.sendObject ? handleSendObject(option) : props.onChange!(value)}
                showSearch
                placeholder={t("common.chooseRoomType")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={data?.body?.data?.map(h => Object.assign(h, {
                    label: h.name,
                    value: h.id
                })).filter((x) => !props.excludedValue || (props.excludedValue && x.value != props.excludedValue))}
            />
        </>
    )
}
